const ProgressSvg = (props) => {
    let { value, animationDuration } = props
    const gradientColors = (value) => {
        const color1 = '#F53C3C';  // Example start end color
        const color2 = '#F5AB3C';  // Example end color

        // Calculate gradient colors based on progress value
        const id = `gradient-${value}`;

        return (
            <defs>
                <linearGradient id={id} gradientTransform="rotate(60)" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="2%" stopColor={color1} style={{ stopOpacity: 1 }} />
                    <stop offset="100%" stopColor={color2} style={{ stopOpacity: 1 }} />
                </linearGradient>
            </defs>
        );
    };
    return (
        <div className="relative size-[3.8rem]">
            <svg className="size-full" width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                {/* Define linear gradient based on value */}
                {gradientColors(value)}
                <defs>
                    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor='#F53C3C' />
                        <stop offset={`100%`} stopColor='#F5AB3C' />
                    </linearGradient>
                </defs>

                {/* Background Circle */}
                <circle cx="18" cy="18" r="16" fill="none" className="stroke-current text-[#e1ecf8] dark:text-neutral-700" strokeWidth="5"></circle>
                <text x="50%" y="50%" fontSize="9" textAnchor="middle" alignmentBaseline="middle" style={{ fill: "url(#gradient)" }}>{value}%</text>
                {/* Progress Circle with dynamic linear gradient and animation */}
                <g className="origin-center -rotate-90 transform">
                    <circle cx="18" cy="18" r="16" fill="none" className="stroke-current" strokeWidth="4" strokeDasharray="100" strokeDashoffset="100" style={{ stroke: `url(#gradient-${value})` }}>
                        {/* Animation to simulate progress */}
                        <animate attributeName="stroke-dashoffset" from="100" to={100 - value} dur={`${animationDuration}ms`} fill="freeze" />
                    </circle>
                </g>
            </svg>
        </div>
    )
}

export default ProgressSvg;